import { API } from "aws-amplify";
import { createNotifications } from "../../src/graphql/mutations";

export default async function MakeNotification(
  type,
  reciever,
  sender,
  name,
  com
) {
  try {
    await API.graphql({
      query: createNotifications,
      variables: {
        input: {
          type: type,
          notificationsRecieverUId: reciever.uId,
          notificationsSenderUId: sender.uId,
          name: name,
          community: com,
        },
      },
    });
  } catch (evt) {
    console.log(evt);
  }
  // return notification;
}
